import config from 'config';
import links from 'helpers/links';

/**
 * Pages the public demo cannot serve; visiting one lands on the dashboard instead.
 * Tiny and data-free on purpose: router.jsx and AtsRouter.jsx import it statically.
 */

/** Reached from emails, OAuth or the payment provider — meaningless without a backend. */
export const DEMO_HIDDEN_PUBLIC_PATHS: string[] = [
  `${config.baseUrl}/validate`,
  links.invite().verify,
  links.invite().confirmAccessRequest,
  links.activateJob().pattern,
  links.newYearExtend().pattern,
  links.publicTransactionReturn().pattern,
];

/** API tokens, the card-payment result page, and loyalty (only a few large employers have it). */
export const DEMO_HIDDEN_APP_PATHS: string[] = [
  links.integrations.pattern,
  links.payments().pattern,
  links.loyaltyReport().pattern,
  links.loyaltyClub().pattern,
];
